import { connect } from 'react-redux';

export const mapStateToProps = ({ locale, localeData }) => ({ locale, i18n: localeData[locale] });

export default (component) => connect(mapStateToProps)(component);
